import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      CLOSE: "Lukk",
    },
    se: {
      CLOSE: "Stäng",
    },
    dk: {
      CLOSE: "Luk",
    },
  } as const
)[language];
